import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import {
  channelPartnerDetail,
  channelPartnerStatusUpdate,
} from "reduxStore/action/channelPartnerAction";
import { useDispatch, useSelector } from "react-redux";
import {
  getFileExtension,
  handleDetailResponse,
  isEmpty,
  seo,
} from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import { userPasswordGenrate, forceLogoutUser } from "reduxStore/action/usersActions";
import usePermission from "utils/usePermission";
import moment from "moment";
import ImageRender from "component/common/ImageRender";
import PdfViewer from "../../component/common/pdfViewer";
import JustoPasswordResetModal from "component/common/JustoPasswordResetModal";
import JustoForceLogoutModal from "component/common/JustoForceLogoutModal";
import "component/common/JustoConfirmModal.css";

const ViewAgentDetails = () => {
  const navigate = useNavigate();
  const [viewData, setViewData] = useState({});
  const [isPdfView, setIsPdfView] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [passwordResetOpen, setPasswordResetOpen] = useState(false);
  const [passwordResetSubmitting, setPasswordResetSubmitting] = useState(false);
  const [forceLogoutOpen, setForceLogoutOpen] = useState(false);
  const [forceLogoutSubmitting, setForceLogoutSubmitting] = useState(false);
  const dispatch = useDispatch();
  const params = useParams();
  const { _id = "" } = params || {};
  const { edit } = usePermission({
    edit: "edit_channelpartner",
  });

  const channelPartnerDetailSelector =
    useSelector((state) => state.channelPartner) || {};

  useEffect(() => {
    getDetail();
  }, []);

  const getDetail = () => {
    dispatch(channelPartnerDetail({ cp_id: _id }));
  };

  useEffect(() => {
    if (channelPartnerDetailSelector.detail) {
      const { response } = channelPartnerDetailSelector;
      if (response?.status === 200) {
        setViewData(handleDetailResponse(response.data));
      }
    }
  }, [channelPartnerDetailSelector]);

  useEffect(() => {
    seo({
      title: "CP Agent Details",
      metaDescription: "Cp agent details",
      canonicalLink: window.location.href,
    });
  }, []);

  const handlePassword = async ({ send_email } = {}) => {
    if (isEmpty(viewData?.login_id)) {
      return;
    }
    setPasswordResetSubmitting(true);
    try {
      await dispatch(
        userPasswordGenrate({
          user_id: viewData.login_id,
          send_email: Boolean(send_email),
        })
      );
      setPasswordResetOpen(false);
    } finally {
      setPasswordResetSubmitting(false);
    }
  };

  const handleForceLogout = async () => {
    if (isEmpty(viewData?.login_id)) {
      return;
    }
    setForceLogoutSubmitting(true);
    try {
      await dispatch(forceLogoutUser({ user_id: viewData.login_id }));
      setForceLogoutOpen(false);
    } finally {
      setForceLogoutSubmitting(false);
    }
  };

  const handleCpVerify = (data) => {
    dispatch(channelPartnerStatusUpdate(data));
    getDetail();
  };
  return isPdfView ? (
    <PdfViewer
      pdfUrl={pdfUrl}
      backButton={() => {
        setIsPdfView(false);
        setPdfUrl(null);
      }}
    />
  ) : (
    <div className="page-body">
      <JustoPasswordResetModal
        open={passwordResetOpen}
        onClose={() =>
          !passwordResetSubmitting && setPasswordResetOpen(false)
        }
        onConfirm={handlePassword}
        submitting={passwordResetSubmitting}
        userName={
          viewData?.agent_name ||
          [viewData?.firstname, viewData?.lastname].filter(Boolean).join(" ")
        }
        email={viewData?.email}
        mobile={viewData?.primary_mobile || viewData?.mobile}
      />
      <JustoForceLogoutModal
        open={forceLogoutOpen}
        onClose={() => !forceLogoutSubmitting && setForceLogoutOpen(false)}
        onConfirm={handleForceLogout}
        submitting={forceLogoutSubmitting}
        userName={
          viewData?.agent_name ||
          [viewData?.firstname, viewData?.lastname].filter(Boolean).join(" ")
        }
        email={viewData?.email}
        mobile={viewData?.primary_mobile || viewData?.mobile}
      />
      {/* Model_start_verify_cp */}
      <div
        className="modal fade"
        id="exampleModal12"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {strings.verifyCP}
              </h5>
              <button
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <h6>{strings.areYouSure}</h6>
              </div>
              <div className="text-center">
                <h6>{strings.youWantVerifyCP}</h6>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                className="btn btn-success mr-5"
                type="button"
                onClick={() => handleCpVerify({ verified: 1, cp_id: _id })}
                data-dismiss="modal"
              >
                {strings.yes}
              </button>
              <button
                className="btn btn-primary"
                type="button"
                data-dismiss="modal"
              >
                {strings.no}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Model_end_verify_cp */}
      <Breadcrumb
        title={strings.agentDetail}
        url={"/channelpartner"}
        parentListing={strings.channelPartnerListing}
        titleactive={strings.viewAgent}
        isBackBtn={true}
      />
      <div className="col-xl-6 xl-100 col-lg-12">
        <div className="card">
          <div className="card-header pb-4">
            <h5 className="pull-left">{strings.agentDetail}</h5>
          </div>
          <div className="card-body">
            <div className="tabbed-card">
              <ul
                className="nav nav-pills nav-primary"
                id="pills-clrtabinfo"
                role="tablist"
              >
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="pills-clrhome-tabinfo"
                    data-toggle="pill"
                    href="#pills-clrhomeinfo"
                    role="tab"
                    aria-controls="pills-clrhome"
                    aria-selected="true"
                  >
                    {strings.stats}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="pills-clrprofile-tabinfo"
                    data-toggle="pill"
                    href="#pills-clrprofileinfo"
                    role="tab"
                    aria-controls="pills-clrprofile"
                    aria-selected="false"
                  >
                    {strings.agencyInfo}
                  </a>
                </li>
                {Number(viewData.verified) === 2 && (
                  <li className="nav-item">
                    <a
                      aria-hidden="true"
                      title="Verify CP"
                      data-toggle="modal"
                      data-original-title="test"
                      data-target="#exampleModal12"
                      className="breadcrumb-item float-right"
                      style={{ color: "#4466f2", padding: 8 }}
                    >
                      {strings.verify}
                    </a>
                  </li>
                )}
                {edit && (
                  <>
                    <li className="nav-item">
                      <a
                        aria-hidden="true"
                        title={strings.forceLogoutUser}
                        className="breadcrumb-item float-right"
                        style={{ color: "#4466f2", padding: 8 }}
                        href="#force-logout"
                        onClick={(e) => {
                          e.preventDefault();
                          setForceLogoutOpen(true);
                        }}
                      >
                        {strings.forceLogoutUser}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        aria-hidden="true"
                        title={strings.userPasswordSend}
                        className="breadcrumb-item float-right"
                        style={{ color: "#4466f2", padding: 8 }}
                        href="#reset-password"
                        onClick={(e) => {
                          e.preventDefault();
                          setPasswordResetOpen(true);
                        }}
                      >
                        {strings.userPasswordSend}
                      </a>
                    </li>
                  </>
                )}
              </ul>
              <div className="tab-content" id="pills-clrtabContentinfo">
                <div
                  className="tab-pane fade show active"
                  id="pills-clrhomeinfo"
                  role="tabpanel"
                  aria-labelledby="pills-clrhome-tabinfo"
                >
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.createBy} :
                      </label>
                    </div>
                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.create_by || "Self Registered"}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.activeBy} :
                      </label>
                    </div>
                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.active_by || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  {viewData?.role_title === "Channel Partner" ? <hr /> : null}
                  {viewData?.role_title === "Channel Partner" ? (
                    <div className="row">
                      <div className="col-md-3 align-items-center mt-2">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.noOfAgent}
                        </label>
                      </div>
                      <div className="col-md-7 align-items-center mt-2">
                        <label
                          htmlFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {viewData?.agent_stats?.total_agent || 0}
                        </label>
                      </div>
                    </div>
                  ) : null}
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.noOfSiteVisit} :
                      </label>
                    </div>
                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.agent_stats?.total_site_visit || 0}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.noOfClosingLead} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.agent_stats?.total_closing_lead || 0}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.closingPercentage} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.agent_stats?.total_closing_percentage
                          ? Number(
                            viewData?.agent_stats?.total_closing_percentage.replace(
                              "%",
                              ""
                            )
                          ).toFixed(2) + "%"
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.lastLogin} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.agent_stats?.last_login
                          ? moment(viewData?.agent_stats?.last_login).format(
                            "DD-MM-yyyy hh:mm a"
                          )
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.lastLeadCreate} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.agent_stats?.last_lead_crate
                          ? moment(
                            viewData?.agent_stats?.last_lead_crate
                          ).format("DD-MM-yyyy hh:mm a")
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.lastSiteVisit} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.agent_stats?.last_site_visit
                          ? moment(
                            viewData?.agent_stats?.last_site_visit
                          ).format("DD-MM-yyyy hh:mm a")
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.lastCloseVisit} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.agent_stats?.last_closing_lead
                          ? moment(
                            viewData?.agent_stats?.last_closing_lead
                          ).format("DD-MM-yyyy hh:mm a")
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-clrprofileinfo"
                  role="tabpanel"
                  aria-labelledby="pills-clrprofile-tabinfo"
                >
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.agent_name} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.agent_name || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.mobileNo} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.primary_mobile || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.email} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.email || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-3 align-items-center mt-2">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.gender} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center mt-2">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.gender
                          ? viewData?.gender === 1
                            ? "Male"
                            : "Female"
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewAgentDetails;
